import api from './api';

// Users
export const fetchAdminUsers = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const { data } = await api.get(`/admin/users?${qs}`);
  return data; // { users, page, totalPages, total }
};

export const toggleUserActivation = async (id, isActive) => {
  const { data } = await api.patch(`/admin/users/${id}/activation`, { isActive });
  return data; // { id, isActive }
};

export const verifyUser = async (id, status, notes) => {
  const { data } = await api.patch(`/admin/users/${id}/verify`, { status, notes });
  return data; // { id, verification }
};

// Audit logs
export const fetchAuditLogs = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const { data } = await api.get(`/admin/audit?${qs}`);
  return data; // { logs, page, totalPages, total }
};

export const fetchStats = async () => {
  const { data } = await api.get('/admin/stats');
  return data; // { metrics, recentUsers, recentAudit }
};

const adminService = {
  fetchAdminUsers,
  toggleUserActivation,
  verifyUser,
  fetchAuditLogs,
  fetchStats,
};

export default adminService;
